// import React from "react";

// import { Circles } from "react-loader-spinner";

// const EditableRow = ({
//   handleEditFormSubmit,
//   isLoadingSave,

//   handleEditFormChange,
//   handleCancelClick,
// }) => {
//   return (
//    <tr>
//          <td></td>
//          <td>
         
//          </td>
//          <td>
//            <input
//              type="text"
//              required="required"
//              placeholder="Edit product type"
//              name="producttype"
//              onChange={handleEditFormChange}
//            ></input>
//          </td>
//          <td>
//            <input
//              type="number"
//              required="required"
//              placeholder="Edit Weight"
//              name="weight"
//              onChange={handleEditFormChange}
//            ></input>
//          </td>
   
//          <td>
//            {/* <input
//              type="text"
//              placeholder="Edit company"
//              name="companyname"
//              onChange={handleEditFormChange}
//            ></input> */}
//          </td>
//          <td>
//            <input
//              type="text"
//              placeholder="Edit fullname"
//              name="fullname"
//              onChange={handleEditFormChange}
//            ></input>
//          </td>
//          <td></td>
   
//          <td>
//            {/* switch rendering */}
//            {isLoadingSave ? (
//              <div className="dib ml2 mr2">
//                <Circles type="Oval" color="#000080" height={20} width={40} />
//              </div>
//            ) : null}
//            <button
//              onClick={handleEditFormSubmit}
//              className="ml2 br-pill bw0 bg-orange hover-bg-yellow white pa2"
//            >
//              Save
//            </button>
//            <button
//              className="ml2 br-pill bw0 bg-orange hover-bg-yellow white pa2"
//              type="button"
//              onClick={handleCancelClick}
//            >
//              Cancel
//            </button>
//          </td>
//        </tr>
//   );
// };

// export default EditableRow;


// working

// import React from "react";
// import { Circles } from "react-loader-spinner";

// const EditableRow = ({
//   isLoadingSave,
//   editFormData,
//   handleEditFormChange,
//   handleEditFormSubmit,
//   handleCancelClick,
// }) => {
//   return (
//     <tr className="bg-washed-yellow">

//       {/* Checkbox column */}
//       <td className="pa2 tc">
//         <input type="checkbox" disabled />
//       </td>

//       {/* ID */}
//       <td className="pa2 fw6 dark-gray">
//         {editFormData?.id}
//       </td>

//       {/* Farmer ID */}
//       <td className="pa2">
//         {editFormData?.farmerid}
//       </td>

//       {/* Product Type */}
//       <td className="pa2">
//         <input
//           type="text"
//           name="producttype"
//           value={editFormData?.producttype || ""}
//           onChange={handleEditFormChange}
//           className="pa2 ba b--light-gray br2 w-100"
//           placeholder="Product Type"
//           required
//         />
//       </td>

//       {/* Weight */}
//       <td className="pa2">
//         <input
//           type="number"
//           name="weight"
//           value={editFormData?.weight || ""}
//           onChange={handleEditFormChange}
//           className="pa2 ba b--light-gray br2 w-100"
//           placeholder="Weight"
//           required
//         />
//       </td>

//       {/* Company */}
//       <td className="pa2">
//         {editFormData?.companyname}
//       </td>

//       {/* Full Name */}
//       <td className="pa2">
//         <input
//           type="text"
//           name="fullname"
//           value={editFormData?.fullname || ""}
//           onChange={handleEditFormChange}
//           className="pa2 ba b--light-gray br2 w-100"
//           placeholder="Full Name"
//         />
//       </td>

//       {/* Approval Status */}
//       <td className="pa2">
//         <select
//           name="approved_status"
//           value={editFormData?.approved_status || "pending"}
//           onChange={handleEditFormChange}
//           className="pa2 ba b--light-gray br2 w-100"
//         >
//           <option value="pending">Pending</option>
//           <option value="approved">Approved</option>
//         </select>
//       </td>

//       {/* Date Approved */}
//       <td className="pa2">
//         {editFormData?.date_approved || "-"}
//       </td>

//       {/* Date Recorded */}
//       <td className="pa2">
//         {editFormData?.daterecorded}
//       </td>

//       {/* Actions */}
//       <td className="pa2 nowrap">

//         {isLoadingSave && (
//           <span className="mr2 dib">
//             <Circles
//               type="Oval"
//               color="#000080"
//               height={20}
//               width={20}
//             />
//           </span>
//         )}

//         <button
//           type="button"
//           onClick={handleEditFormSubmit}
//           className="mr2 ph3 pv2 br-pill bn bg-dark-green white pointer hover-bg-green"
//         >
//           Save
//         </button>

//         <button
//           type="button"
//           onClick={handleCancelClick}
//           className="ph3 pv2 br-pill bn bg-light-red dark-red pointer hover-bg-red hover-white"
//         >
//           Cancel
//         </button>

//       </td>

//     </tr>
//   );
// };

// export default EditableRow;


// // new matching our new UI
// import React from "react";
// import { Circles } from "react-loader-spinner";

// const EditableRow = ({
//   isLoadingSave,
//   editFormData,
//   handleEditFormChange,
//   handleEditFormSubmit,
//   handleCancelClick,
// }) => {
//   return (
//     <tr
//       className="
//         bg-washed-yellow
//         bb
//         b--gold
//       "
//     >
//       {/* Select Column */}
//       <td className="pa2 tc nowrap">
//         <input type="checkbox" disabled />
//       </td>

//       {/* ID */}
//       <td className="pa2 fw6 dark-gray nowrap">
//         {editFormData?.id}
//       </td>

//       {/* Farmer ID */}
//       <td className="pa2 nowrap">
//         {editFormData?.farmerid}
//       </td>

//       {/* Product Type */}
//       <td className="pa2 nowrap">
//         <input
//           type="text"
//           name="producttype"
//           value={editFormData?.producttype || ""}
//           onChange={handleEditFormChange}
//           placeholder="Product Type"
//           className="
//             pa2
//             ba
//             b--light-gray
//             br2
//             bg-white
//             nowrap
//           "
//           style={{ minWidth: "160px" }}
//           required
//         />
//       </td>

//       {/* Weight */}
//       <td className="pa2 nowrap">
//         <input
//           type="number"
//           name="weight"
//           value={editFormData?.weight || ""}
//           onChange={handleEditFormChange}
//           placeholder="Weight"
//           className="
//             pa2
//             ba
//             b--light-gray
//             br2
//             bg-white
//           "
//           style={{ minWidth: "100px" }}
//           required
//         />
//       </td>

//       {/* Company */}
//       <td className="pa2 nowrap fw5">
//         {editFormData?.companyname}
//       </td>

//       {/* Full Name */}
//       <td className="pa2 nowrap">
//         <input
//           type="text"
//           name="fullname"
//           value={editFormData?.fullname || ""}
//           onChange={handleEditFormChange}
//           placeholder="Full Name"
//           className="
//             pa2
//             ba
//             b--light-gray
//             br2
//             bg-white
//           "
//           style={{ minWidth: "220px" }}
//         />
//       </td>

//       {/* Approval */}
//       <td className="pa2 tc nowrap">
//         <select
//           name="approved_status"
//           value={editFormData?.approved_status || "pending"}
//           onChange={handleEditFormChange}
//           className="
//             pa2
//             ba
//             b--light-gray
//             br2
//             bg-white
//             fw6
//           "
//         >
//           <option value="pending">
//             Not Approved
//           </option>

//           <option value="approved">
//             Approved
//           </option>
//         </select>
//       </td>

//       {/* Date Approved */}
//       <td className="pa2 tc nowrap">
//         <span className="dark-gray">
//           {editFormData?.date_approved || "-"}
//         </span>
//       </td>

//       {/* Date Recorded */}
//       <td className="pa2 tc nowrap">
//         <span className="dark-gray">
//           {editFormData?.daterecorded}
//         </span>
//       </td>

//       {/* Actions */}
//       <td className="pa2 tc nowrap">

//         {isLoadingSave && (
//           <span className="dib mr3 v-mid">
//             <Circles
//               height={24}
//               width={24}
//               color="#ffb700"
//             />
//           </span>
//         )}

//         <button
//           type="button"
//           onClick={handleEditFormSubmit}
//           disabled={isLoadingSave}
//           className="
//             bn
//             br-pill
//             bg-dark-green
//             white
//             pointer
//             fw6
//             ph3
//             pv2
//             mr2
//             hover-bg-green
//           "
//         >
//           Save
//         </button>

//         <button
//           type="button"
//           onClick={handleCancelClick}
//           disabled={isLoadingSave}
//           className="
//             bn
//             br-pill
//             bg-light-red
//             dark-red
//             pointer
//             fw6
//             ph3
//             pv2
//             hover-bg-red
//             hover-white
//           "
//         >
//           Cancel
//         </button>

//       </td>
//     </tr>
//   );
// };

// export default EditableRow;


// new with company edit
// new matching our new UI
import React from "react";
import { Circles } from "react-loader-spinner";

const EditableRow = ({
  isLoadingSave,
  editFormData,
  handleEditFormChange,
  handleEditFormSubmit,
  handleCancelClick,
  companiesList = [],
  canEditCompany = true, // pass false for normal admins/clerks
}) => {
  // Normalize the list to unique, sorted names; keep the current value selectable
  const companyOptions = React.useMemo(() => {
    const names = (companiesList || [])
      .map((c) =>
        typeof c === "string" ? c : c?.name || c?.company || c?.companyname || ""
      )
      .map((n) => String(n).trim())
      .filter(Boolean);

    if (editFormData?.companyname && !names.includes(editFormData.companyname)) {
      names.push(editFormData.companyname);
    }

    return [...new Set(names)].sort((a, b) => a.localeCompare(b));
  }, [companiesList, editFormData?.companyname]);

  return (
    <tr className="bg-washed-yellow bb b--gold">
      {/* Select Column */}
      <td className="pa2 tc nowrap">
        <input type="checkbox" disabled />
      </td>

      {/* ID */}
      <td className="pa2 fw6 dark-gray nowrap">{editFormData?.id}</td>

      {/* Farmer ID */}
      <td className="pa2 nowrap">{editFormData?.farmerid}</td>

      {/* Product Type */}
      <td className="pa2 nowrap">
        <input
          type="text"
          name="producttype"
          value={editFormData?.producttype || ""}
          onChange={handleEditFormChange}
          placeholder="Product Type"
          className="pa2 ba b--light-gray br2 bg-white nowrap"
          style={{ minWidth: "160px" }}
          required
        />
      </td>

      {/* Weight */}
      <td className="pa2 nowrap">
        <input
          type="number"
          name="weight"
          value={editFormData?.weight || ""}
          onChange={handleEditFormChange}
          placeholder="Weight"
          className="pa2 ba b--light-gray br2 bg-white"
          style={{ minWidth: "100px" }}
          required
        />
      </td>

      {/* Company */}
      <td className="pa2 nowrap fw5">
        {canEditCompany ? (
          <select
            name="companyname"
            value={editFormData?.companyname || ""}
            onChange={handleEditFormChange}
            className="pa2 ba b--light-gray br2 bg-white"
            style={{ minWidth: "180px" }}
          >
            <option value="" disabled>
              Select company
            </option>
            {companyOptions.map((name) => (
              <option key={name} value={name}>
                {name}
              </option>
            ))}
          </select>
        ) : (
          editFormData?.companyname
        )}
      </td>

      {/* Full Name */}
      <td className="pa2 nowrap">
        <input
          type="text"
          name="fullname"
          value={editFormData?.fullname || ""}
          onChange={handleEditFormChange}
          placeholder="Full Name"
          className="pa2 ba b--light-gray br2 bg-white"
          style={{ minWidth: "220px" }}
        />
      </td>

      {/* Approval */}
      <td className="pa2 tc nowrap">
        <select
          name="approved_status"
          value={editFormData?.approved_status || "pending"}
          onChange={handleEditFormChange}
          className="pa2 ba b--light-gray br2 bg-white fw6"
        >
          <option value="pending">Not Approved</option>
          <option value="approved">Approved</option>
        </select>
      </td>

      {/* Date Approved */}
      <td className="pa2 tc nowrap">
        <span className="dark-gray">{editFormData?.date_approved || "-"}</span>
      </td>

      {/* Date Recorded */}
      <td className="pa2 tc nowrap">
        <span className="dark-gray">{editFormData?.daterecorded}</span>
      </td>

      {/* Actions */}
      <td className="pa2 tc nowrap">
        {isLoadingSave && (
          <span className="dib mr3 v-mid">
            <Circles height={24} width={24} color="#ffb700" />
          </span>
        )}

        <button
          type="button"
          onClick={handleEditFormSubmit}
          disabled={isLoadingSave}
          className="bn br-pill bg-dark-green white pointer fw6 ph3 pv2 mr2 hover-bg-green"
        >
          Save
        </button>

        <button
          type="button"
          onClick={handleCancelClick}
          disabled={isLoadingSave}
          className="bn br-pill bg-light-red dark-red pointer fw6 ph3 pv2 hover-bg-red hover-white"
        >
          Cancel
        </button>
      </td>
    </tr>
  );
};

export default EditableRow;